import {observable, action} from "mobx"
import {v4 as uuidv4} from "uuid"
import api from "../../global/actions/api"
import {getUserCompanyInfo} from "../../global/helpers/actions"
import GlobalStore from "../../global/store/GlobalStore"
import InfoStore from "../../global/store/InfoStore"
import RouterStore from "../../global/store/RouterStore"
import DeviceDialogStore from "./DeviceDialogStore"
import moment from "moment"

class RequestFormStore {
	@observable applicantChipForm = []
	@observable locationChipForm = []
	@observable requestStates = []

	@observable tabValue = "detail"

	@observable dropedFiles0 = []
	@observable dropedFiles1 = []
	@observable dropedFiles2 = []
	@observable dropedFiles3 = []
	@observable dropedFiles4 = []
	@observable dropedFiles5 = []
	@observable dropedFiles6 = []
	@observable attachmentTemplates = [
		"GD:GDREQ:ENERGETICAUDIT",
		"GD:GDREQ:OZE",
		"GD:GDREQ:MINIMALDECLARATION",
		"GD:GDREQ:DIVISIONACTIVITY",
		"GD:GDREQ:POWEROFATTORNEY",
		"GD:GDREQ:AFFIDAVIT"
	]

	@observable currentRequestStatus = null

	formRef = null

	defaultFormValues = {}

	@action isSameFormValues() {
		return JSON.stringify(this.defaultFormValues) === JSON.stringify(this.formRef.values())
	}

	@action deleteLoadedAttachemnt(id, dropzoneIndex, attachmentIndex) {
		let data = {
			_id: id,
			active: false
		}
		api
			.saveAttachment(data)
			.call()
			.then(() => {
				this[`dropedFiles${dropzoneIndex}`].splice(attachmentIndex, 1)
			})
	}

	@action resetDropzones() {
		this.dropedFiles0 = []
		this.dropedFiles1 = []
		this.dropedFiles2 = []
		this.dropedFiles3 = []
		this.dropedFiles4 = []
		this.dropedFiles5 = []
		this.dropedFiles6 = []
	}

	generateDataAndSave(form, version, callback) {
		let droppedFiles = [
			...this.dropedFiles0,
			...this.dropedFiles1,
			...this.dropedFiles2,
			...this.dropedFiles3,
			...this.dropedFiles4,
			...this.dropedFiles5,
			...this.dropedFiles6
		]
		if (isSafe(droppedFiles) && droppedFiles.length) {
			let req = []
			let files = droppedFiles
			var saveFunction = this.save

			let binaryDataArr = []
			let getdata = function(index) {
				let data = files[index]
				if (isEmpty(data._id)) {
					let binaryData

					var reader = new FileReader()
					reader.readAsBinaryString(data)

					reader.onloadend = function() {
						binaryData = reader.result
						binaryDataArr.push(binaryData)
						req.push({
							attachment_id: isNotEmpty(data._id) ? data._id : null,
							_ref: false,
							active: true,
							content_type: isNotEmpty(data.type) ? data.type : "application/octet-stream",
							// content: binaryData.split(",")[1], ???
							content: btoa(binaryData),
							type: data.templateName,
							file_name: data.name,
							size: data.size
						})
						if (files.length > index + 1) {
							getdata(index + 1)
						} else {
							saveFunction(form, req, version, callback)
						}
					}
				} else {
					req.push({
						attachment_id: data._id,
						file_name: data.name,
						type: data.databaseType,
						content_type: isNotEmpty(data.type) ? data.type : "application/pdf",
						_ref: false,
						active: true
					})

					if (files.length > index + 1) {
						getdata(index + 1)
					} else {
						saveFunction(form, req, version, callback)
					}
				}
			}
			getdata(0)
		} else {
			this.save(form, [], version, callback)
		}
	}

	@action changeRecordStatus(form) {
		const values = form.values()

		const req = {
			status_id: values.request_status,
			at: values.paid_date,
			photovoltaic_panel_value: values.photovoltaic_panels,
			heat_pump_value: values.heat_pumps,
			solar_collector_value: values.solar_collectors,
			wind_turbine_value: values.wind_turbines,
			ea_grant_value: values.paid_ea_grant
		}

		api
			.changeRecordStatus(values.request_id, req)
			.call()
			.then((res) => {
				if (isNotEmpty(res)) {
					RouterStore.push("/requests")
					GlobalStore.setNotificationMessage("Stav úspešne zmenený", "", "success")
				} else {
					GlobalStore.setNotificationMessage("Stav žiadosti nebol zmenený", "", "error")
				}
			})
	}

	@action save(form, dropzoneData, version, callback) {
		GlobalStore.loading(true)
		const formVals = form.values()

		let req = {
			record_id: isNotEmpty(formVals.request_id) ? formVals.request_id : null, // vyplnaj pri UPDATE
			_type: "GD.API.JSON.Proxy.Request.GDRequest",
			status_id: formVals.status,
			type_id: "GD.Data.Request.GDRequest",
			attached_files: dropzoneData,
			company_data: {
				company: getUserCompanyInfo().id,
				tax_identification_number: formVals.dic,
				vat_identification_number: formVals.icdph,
				legal_form_id: formVals.companyLegalForm, //(Entity.CL.LegalForm)
				iban: formVals.companyIBAN,
				communication_method: formVals.methodOfCommunication,
				company_size_id: formVals.companySize,
				classification_id: formVals.skNace,
				oa_address: {
					obj_city: {
						_type: "Entity.CL.Address.City",
						_id: formVals.companyCity
					},
					primary: true,
					street_plain: formVals.companyStreet,
					type: {
						_type: "Entity.CL.AddressType",
						_id: "OA"
					}
				}
			},
			project_implementations_data: [],
			statutories_data: [],
			round_data: {round_id: formVals.round_id},
			request_for_ea_grant: formVals.contributionForEnergyAudit,
			expected_voucher_amount: formVals.expected_voucher_amount
		}

		//Devices
		if (DeviceDialogStore.places.length > 0) {
			const projectData = DeviceDialogStore.places.map((plc) => {
				const place = {
					city_id: plc.cityId,
					street_plain: plc.street,
					devices_data: []
				}

				plc.devices.forEach((device) => {
					const deviceObj = {
						device_id: device.deviceId,
						power: device.power
					}

					if (isNotEmpty(device.catastral)) {
						deviceObj["cadastral_name"] = device.catastral
					}

					if (isNotEmpty(device.capacity)) {
						deviceObj["accumulation_capacity"] = device.capacity
					}

					if (isNotEmpty(device.parcel)) {
						deviceObj["lot_number"] = device.parcel
					}

					place.devices_data.push(deviceObj)
				})

				return place
			})

			req.project_implementations_data = projectData
		}

		//Kontaktna osoba
		if (
			isNotEmpty(formVals.contactPersonName) ||
			isNotEmpty(formVals.contactPersonMail) ||
			isNotEmpty(formVals.contactPersonPhone)
		) {
			req["request_contact_data"] = {
				name: formVals.contactPersonName,
				email: formVals.contactPersonMail,
				phone: formVals.contactPersonPhone
			}
		}

		if (
			isNotEmpty(formVals.authorizedPersonName) ||
			isNotEmpty(formVals.authorizedPersonMail) ||
			isNotEmpty(formVals.authorizedPersonPhone)
		) {
			req["empowered_contact_data"] = {
				name: formVals.authorizedPersonName,
				email: formVals.authorizedPersonMail,
				phone: formVals.authorizedPersonPhone
			}
		}

		//Statutari
		let statutarData = isEmpty(formVals.applicantChipForm) ? [] : JSON.parse(formVals.applicantChipForm)
		statutarData.map((statutar) => {
			req["statutories_data"].push(statutar.name)
		})

		api
			.saveRequest(req)
			.call()
			.then((response) => {
				GlobalStore.setNotificationMessage(
					version == "final" ? "Odoslanie prebehlo úspešne" : "Uloženie prebehlo úspešne",
					"",
					"success"
				)
				DeviceDialogStore.places = []
				if (isSafe(callback)) {
					callback(response._id)
				}
			})
	}

	@action load(form, id) {
		GlobalStore.loading(true)
		api
			.loadRequestWithAtt(id)
			.call()
			.then((response) => {
				form.reset()
				const company = response.company_data || {}
				const request_contact_data = response.request_contact_data || {}
				const companyAddresses = company.oa_address || {}
				const empowered_contact_data = response.empowered_contact_data || {}

				let formObj = {
					request_id: response.record_id,
					gd_request_id: response.gd_request_id,
					status: response.status_id,
					dic: company.tax_identification_number,
					ico: company.identifier,
					icdph: company.vat_identification_number,
					companyName: company.name,
					companySize: company.company_size_id,
					companyStreet: companyAddresses.street_plain,
					companyCity: companyAddresses.obj_city,
					companyLegalForm: company.legal_form_id,
					companyIBAN: company.iban,
					contactPersonName: request_contact_data.name,
					contactPersonMail: request_contact_data.email,
					contactPersonPhone: request_contact_data.phone,
					skNace: company.classification_id,
					authorizedPersonMail: empowered_contact_data.email,
					authorizedPersonName: empowered_contact_data.name,
					authorizedPersonPhone: empowered_contact_data.phone,
					round_id: isSafe(response.round_data) ? response.round_data.round_id : null,
					personalDataProvided: true,
					contributionForEnergyAudit: response.request_for_ea_grant,
					request_status: response.status_id !== "sent" ? response.status_id : null,
					expected_voucher_amount: response.expected_voucher_amount,
					wind_turbines: (response.paid_voucher_wind_turbine || 0).toFixed(2),
					solar_collectors: (response.paid_voucher_solar_collector || 0).toFixed(2),
					heat_pumps: (response.paid_voucher_heat_pump || 0).toFixed(2),
					photovoltaic_panels: (response.paid_voucher_photovoltaic_panel || 0).toFixed(2),
					paid_ea_grant: (response.paid_ea_grant || 0).toFixed(2),
					methodOfCommunication: company.communication_method
				}

				if (response.status_id === "contracted") {
					formObj.wind_turbines = (response.contracted_voucher_wind_turbine || 0).toFixed(2)
					formObj.solar_collectors = (response.contracted_voucher_solar_collector || 0).toFixed(2)
					formObj.heat_pumps = (response.contracted_voucher_heat_pump || 0).toFixed(2)
					formObj.photovoltaic_panels = (response.contracted_voucher_photovoltaic_panel || 0).toFixed(2)
					formObj.paid_ea_grant = (response.contracted_ea_grant || 0).toFixed(2)
				}

				this.currentRequestStatus = response.status_id

				if (isSafe(response.round_data)) {
					const round = response.round_data

					formObj.round_text = `${round.region_type_code_ext} + ${round.devide_group_name_ext} ${moment(
						round.validity_from
					).format("DD.MM.YYYY")} - ${moment(round.validity_to).format("DD.MM.YYYY")}`
				}

				if (isSafe(response.statutories_data) && response.statutories_data.length > 0) {
					let statutors = []
					response.statutories_data.forEach((statutar) => {
						statutors.push({
							name: statutar
						})
					})
					formObj.applicantChipForm = JSON.stringify(statutors)
				} else {
					formObj.applicantChipForm = JSON.stringify([{name: ""}])
				}

				if (isSafe(response.project_implementations_data) && response.project_implementations_data.length > 0) {
					const places = []

					response.project_implementations_data.forEach((place) => {
						const placeObj = {
							cityId: place.city_id,
							city: place.city_with_county, //TODO: city_name BE
							street: place.street_plain,
							devices: []
						}

						place.devices_data.forEach((device) => {
							placeObj.devices.push({
								_id: uuidv4(),
								deviceId: device.device_id,
								device: device.device_name_ext,
								power: device.power,
								capacity: device.accumulation_capacity,
								catastral: device.cadastral_name,
								parcel: device.lot_number
							})
						})

						places.push(placeObj)
					})

					DeviceDialogStore.places = places
				}

				if (isSafe(response.attached_files) && response.attached_files.length) {
					response.attached_files.forEach((attachment) => {
						// const blob = b64toBlob(attachment.content)
						let tmp = {}
						// new Blob([blob], {
						// 	type: attachment.content_type
						// })
						tmp.name = attachment.file_name
						tmp._id = attachment.attachment_id
						tmp.databaseType = attachment.type
						if (attachment.type === "GD:GDREQ:ENERGETICAUDIT") {
							this.dropedFiles0.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:OZE") {
							this.dropedFiles1.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:MINIMALDECLARATION") {
							this.dropedFiles2.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:DIVISIONACTIVITY") {
							this.dropedFiles3.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:POWEROFATTORNEY") {
							this.dropedFiles4.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:AFFIDAVIT") {
							this.dropedFiles5.push(tmp)
						}
					})
				}

				if (isNotEmpty(response.event_data)) {
					const states = []

					const eventData = response.event_data

					if (isNotEmpty(eventData)) {
						if (response.status_id === "withdrawn") {
							formObj.paid_date = response.event_data.withdrawn_date_time
						}
						if (response.status_id === "sent") {
							formObj.paid_date = response.event_data.sent_date_time
						}
						if (response.status_id === "reject") {
							formObj.paid_date = response.event_data.rejected_date_time
						}
						if (response.status_id === "paid") {
							formObj.paid_date = response.event_data.paid_date_time
						}
						if (response.status_id === "inp") {
							formObj.paid_date = response.event_data.registered_date_time
						}
						if (response.status_id === "instack") {
							formObj.paid_date = response.event_data.in_stack_date_time
						}
						if (response.status_id === "contracted") {
							formObj.paid_date = response.event_data.contracted_date_time
						}
						if (response.status_id === "stopped") {
							formObj.paid_date = response.event_data.stopped_date_time
						}

						if (isNotEmpty(eventData.registered_date_time)) {
							states.push({
								date: eventData.registered_date_time,
								login: eventData.registered_login,
								state: "registrovaná"
							})
						}

						if (isNotEmpty(eventData.sent_date_time)) {
							states.push({
								date: eventData.sent_date_time,
								login: eventData.sent_login,
								state: "prijatá"
							})
						}

						if (isNotEmpty(eventData.paid_date_time)) {
							states.push({
								date: eventData.paid_date_time,
								login: eventData.paid_login,
								state: "uhradená"
							})
						}

						if (isNotEmpty(eventData.rejected_date_time)) {
							states.push({
								date: eventData.rejected_date_time,
								login: eventData.rejected_login,
								state: "zamietnutá"
							})
						}

						if (isNotEmpty(eventData.withdrawn_date_time)) {
							states.push({
								date: eventData.withdrawn_date_time,
								login: eventData.withdrawn_login,
								state: "späťvzatá"
							})
						}

						if (isNotEmpty(eventData.in_stack_date_time)) {
							states.push({
								date: eventData.in_stack_date_time,
								login: eventData.in_stack_login,
								state: "v zásobníku"
							})
						}

						if (isNotEmpty(eventData.contracted_date_time)) {
							states.push({
								date: eventData.contracted_date_time,
								login: eventData.contracted_login,
								state: "zazmluvnená"
							})
						}

						if (isNotEmpty(eventData.stopped_date_time)) {
							states.push({
								date: eventData.stopped_date_time,
								login: eventData.contracted_login,
								state: "zastavené konanie"
							})
						}

						this.requestStates = states
					}
				}

				form.set(formObj)

				this.defaultFormValues = form.values()

				GlobalStore.loading(false)
			})
	}

	downloadSpiecificTemplate(uri, name) {
		api.downloadFile(uri, name)
	}

	validateDraft(form, callback) {
		const formVals = form.values()

		//Polia ktore su req pri drafte
		if (
			isEmpty(formVals.companyName) ||
			isEmpty(formVals.companyLegalForm) ||
			isEmpty(formVals.companyCity) ||
			isEmpty(formVals.companyStreet) ||
			isEmpty(formVals.dic) ||
			isEmpty(formVals.icdph) ||
			isEmpty(formVals.companyIBAN)
		) {
			GlobalStore.setNotificationMessage(
				`Polia "Obchodné meno", Oprávnená oblasť, Základná charakteristika Žiadateľa", "Právna forma", "Obec", "Kraj", "Ulica", "Popisné číslo", "PSČ" sú povinné pre uloženie rozpracovanei verzie`,
				null,
				"error"
			)
		} else {
			callback()
		}
	}

	async loadCodelistAndForm(form, id) {
		GlobalStore.loading(true)
		this.load(form, id)
	}

	handleFormForIpceiRequest(form) {
		form.$("projectName").value = "Dokumentácia pre notifikačný proces IPCEI"
	}

	loadCompanyInfo(form) {
		GlobalStore.loading(true)
		const id = getUserCompanyInfo()._id
		api
			.loadCompanyInfo(id)
			.call()
			.then((company) => {
				form.$("companyName").value = company.name
				form.$("ico").value = company.identifier
				form.$("companyDesc").value = isSafe(company.type) ? company.type.code : ""
				form.$("companyLegalForm").value = isSafe(company.legal_form) ? company.legal_form.code : ""
				form.$("dic").value = company.tax_identification_number
				form.$("icdph").value = company.vat_identification_number
				let orgunit = company.specific_rels.find((row) => row._type == "INN.Data.Entity.OrgUnit")
				if (isSafe(orgunit) && isSafe(orgunit.addresses)) {
					let address = orgunit.addresses.find(
						(row) => row._type == "Entity.Data.Address" && row.active == true && row.type._id == "OA"
					)
					if (isSafe(address)) {
						form.$("companyRegion").value = isSafe(address.region) ? address.region._id : ""
						form.$("companyCity").value = isSafe(address.obj_city) ? address.obj_city._id : ""
						form.$("companyStreet").value = address.street_plain
						form.$("companyStreetNumber").value = address.house_number
						form.$("companyPSC").value = address.zip_plain
					}

					let account = orgunit.accounts.find((row) => row._type == "Fin.Data.BankAccount")
					if (isSafe(account)) {
						form.$("companyIBAN").value = account.number
					}
				}

				this.checkRegionAvailability(form)
				GlobalStore.loading(false)
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
	}

	checkRegionAvailability(form) {
		const {companyRegion} = form.values()
		if (isNotEmpty(companyRegion)) {
			const req = {
				region_id: companyRegion
			}

			api
				.regionRestriction(req)
				.call()
				.then((response) => {
					if (
						(isSafe(response) && response.CallValidityIsNow == 0) ||
						(isSafe(response) &&
							isSafe(response.Regions) &&
							isSafe(response.Regions[0]) &&
							response.Regions[0].ValidityIsNow == 0)
					) {
						InfoStore.open(
							"Aktuálne nie je možné podať ŽoIP so sídlom podnikania v rámci Vášho kraja. Viac informácií je dostupných v rámci oznámenia zverejnenom na webovom sídle www.siea.sk/inovacie/inovacnepoukazky/ .",
							"Upozornenie"
						)
					}
				})
		}
	}
}

var singleton = new RequestFormStore()
export default singleton

